// noinspection JSUnusedGlobalSymbols

import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the unit tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['simCards/gdspoFindSimCardsWidgetModule/get']
}

/**
 * Returns the sets of selected SIM cards.
 *
 * @return Object
 */
export const selectedSimCardSets = () => {
  return store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets']
}

/**
 * Returns SIM cards that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedSimCards = (set) => {
  if (store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets'].hasOwnProperty(set)) {
    return store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns SIM cards that are selected for the specified set as an array
 *
 * @param set String
 *
 * @return Array
 */
export const selectedSimCardsAsArray = (set) => {
  if (store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets'].hasOwnProperty(set)) {
    const simCards = store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets'][set]
    const simCardIds = Object.keys(simCards)
    let results = []
    simCardIds.forEach(simCardId => {
      results.push(simCards[simCardId])
    })
    return results
  } else {
    return []
  }
}

/**
 * Returns the first selected unit in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedSimCard = (set) => {
  if (store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets'].hasOwnProperty(set)) {
    const simCards = store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets'][set]
    const simCardIds = Object.keys(simCards)
    if (simCardIds.length > 0) {
      return simCards[simCardIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns true if the specified unit is selected within the supplied set.
 *
 * @param set String
 * @param id String
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedSimCards(set).hasOwnProperty(id)
}

/**
 * Load the status data of the SIM cards being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('simCards/gdspoFindSimCardsWidgetModule/query')
}

/**
 * Add a map or array of object SIM cards that have been selected within
 * the specified set.
 *
 * @param set String
 * @param simCards Array|Map
 */
export const addSelectedSimCards = (set, simCards) => {
  store.commit('simCards/gdspoFindSimCardsWidgetModule/addSelectedSimCards', { set, simCards })
}

/**
 * Removes an array of SIM cards from the set's list of selected SIM cards.
 * The array must contain the list SIM cards that are no longer selected.
 *
 * @param set String
 * @param simCards cards Array
 */
export const removeSelectedSimCards = (set, simCards) => {
  store.commit('simCards/gdspoFindSimCardsWidgetModule/removeSelectedSimCards', { set, simCards })
}

/**
 * Return all selected SIM cards
 *
 * @param set
 * @returns {*}
 */
export const simCardSelectionSets = (set) => {
  return store.getters['simCards/gdspoFindSimCardsWidgetModule/simCardSelectionSets'][set]
}

/**
 * Clears all selected SIM cards within a specified set.
 */
export const clearSelectedSimCards = (set) => {
  store.commit('simCards/gdspoFindSimCardsWidgetModule/clearSelectedSimCards', set)
}

/**
 * Clears all selected SIM cards.
 */
export const clearAllSelectedSimCards = () => {
  store.commit('simCards/gdspoFindSimCardsWidgetModule/clearAllSelectedSimCards')
}

/**
 * Returns the selected unit count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedSimCardCount = (set) => {
  return Object.keys(selectedSimCards(set)).length
}

/**
 * Clears all SIM cards from being tracked.
 */
export const purge = () => {
  store.commit('simCards/gdspoFindSimCardsWidgetModule/purge')
}



// WEBPACK FOOTER //
// ./src/store/sim-cards/gdspo/gdspoFindSimCardsWidget.helpers.js